/* Source: src/mt-includes/widgets/tabs/src/frontend/init.js*/
angular.module('website.widget.tabs', []);
